import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { TREND_DETAILS } from './url-constants';

type TrendsDetailsEndpointSpecification = ApiEndpointSpecification;
export const TrendsDetailsEndpointSpecification: TrendsDetailsEndpointSpecification = {
    url: TREND_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'TrendsDetailsRequestParams',
    requestBodySchemaName: 'TrendsDetailsRequestBody',
    okResponseSchemaName: 'TrendsDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeTrendsDetails = Helpers.makeApiRequestFn<
    Types.TrendsDetailsRequestParams,
    Types.TrendsDetailsRequestBody,
    Types.TrendsDetailsOkResponse
>(TrendsDetailsEndpointSpecification);
